import { render, staticRenderFns } from "./LanguageSwitch.vue?vue&type=template&id=d9c9ab34"
import script from "@/components/language-switch/LanguageSwitch.ts?vue&type=script&lang=ts&external"
export * from "@/components/language-switch/LanguageSwitch.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/language-switch/language-switch.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports